import React from 'react';
import Menu from '../Menu/Menu';
import appon from '../../images/appon.png'
import { Card, Col, Image, Row } from 'react-bootstrap';
import Footer from '../Footer/Footer';

const Appon = () => {
    return (
        <div>
            <Menu></Menu>
            <Card className='about-me m-auto mt-5' style={{ width: '90%' }}>
            <Card.Body>
            <p className='section-title'>APPON RESPONSIVE WEBSIE</p>
            <Row data-aos="zoom-in" data-aos-easing="ease-out-cubic"
        data-aos-duration="1000" className='project-div mt-4'>
                  
                  <Col xs={12} sm={12} md={6}>
                      {/* <p style={{fontFamily:'Montserrat',color:'rgb(90, 89, 89)',fontWeight:'700'}}>APPON RESPONSIVE WEBSIE</p> */}
                      <p style={{fontSize:'14px',color:'rgb(90, 89, 89)'}}>
                          <span style={{fontWeight:'700'}}>Technologies Used:</span>
                          HTML, CSS, Bootstrap, jQuery
                      </p>
                      <p style={{fontSize:'14px'}}>
                      It’s a fully responsive website.
                      </p>
                      <div className='site-links' style={{fontSize:'14px',marginBottom:'20px'}}>
                         <a rel='noreferrer' target="_blank" href="https://github.com/somiyaPrity/Apon-responsive-webpage-">Code</a>
                         
                         <a rel='noreferrer' target="_blank" href="https://somiyaprity.github.io/Apon-responsive-webpage-/">Live Site</a>
                      </div>
                  </Col>
                  <Col xs={12} sm={12} md={6}>
                  <Image src={appon}  rounded fluid />
                      
                  </Col>
              </Row>
              </Card.Body>
            </Card>
            <Footer></Footer>
        </div>
    );
};

export default Appon;